import Raven from 'raven-js';
import devLogger from 'react-utils/devLogger';
import { startTrial } from 'self-service-api/api/startTrial';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
export const activateTrial = ({
  activeTrials,
  expiredTrials,
  isMultiTrial,
  upgradeData
}) => {
  const {
    trialId,
    source,
    duration
  } = upgradeData;
  if (!trialId) {
    const error = new Error('Missing trialId for trial activation');
    devLogger.warn({
      message: error.message,
      key: 'TrialActivationButton'
    });
    Raven.captureException(error);
    return Promise.reject(error);
  }
  const currentDate = new Date();
  const endDate = currentDate.setDate(currentDate.getDate() + duration).valueOf();
  const trackingProperties = Object.assign({}, getUpgradeDataTrackingProperties(upgradeData), {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    trialId: upgradeData.trialId,
    duration
  });
  return startTrial({
    trialId,
    endDate,
    trialSource: source
  }).then(() => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'activation succeeded'
    }, trackingProperties));
  }).catch(error => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'activation failed'
    }, trackingProperties));
    devLogger.warn({
      message: error.message,
      key: 'TrialActivationButton'
    });
    Raven.captureException(new Error('Trial activation failed', {
      cause: error
    }), {
      extra: {
        trialId: upgradeData.trialId,
        activeTrials,
        expiredTrials,
        isMultiTrial,
        duration,
        app: upgradeData.app,
        screen: upgradeData.screen
      },
      fingerprint: ['trialActivationFailed']
    });
    throw error;
  });
};